import { useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2, Upload, X } from "lucide-react";
import { errMsg, fileUrl, useApi } from "@/lib/api";

export const FileField = ({ value = [], onChange, multiple = false, accept = "application/pdf,image/*", label = "Subir archivo", testId }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const [names, setNames] = useState({});
  const ids = Array.isArray(value) ? value : value ? [value] : [];

  const onFiles = async (files) => {
    setBusy(true);
    let next = multiple ? [...ids] : [];
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api("post", "/uploads", fd);
        setNames((n) => ({ ...n, [data.id]: data.original_filename }));
        next = multiple ? [...next, data.id] : [data.id];
      } catch (e) {
        toast.error(`${file.name}: ${errMsg(e)}`);
      }
    }
    onChange(multiple ? next : next[0] || null);
    setBusy(false);
  };

  const remove = (id) => onChange(multiple ? ids.filter((x) => x !== id) : null);

  return (
    <div className="space-y-2">
      <label className="inline-flex items-center gap-2 h-10 px-4 rounded-full border border-slate-300 text-sm text-slate-700 hover:border-[#00c487] cursor-pointer transition-colors" data-testid={testId}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {busy ? "Subiendo..." : label}
        <input type="file" className="hidden" accept={accept} multiple={multiple} disabled={busy} onChange={(e) => { onFiles([...e.target.files]); e.target.value = ""; }} data-testid={`${testId}-input`} />
      </label>
      <div className="flex flex-wrap gap-2">
        {ids.map((id) => (
          <span key={id} className="flex items-center gap-1.5 text-xs bg-slate-100 rounded-lg px-3 py-1.5" data-testid={`${testId}-item`}>
            <FileText className="w-3.5 h-3.5" />
            <a href={fileUrl(id)} target="_blank" rel="noreferrer" className="hover:underline">{names[id] || "Documento cargado"}</a>
            <button type="button" onClick={() => remove(id)} aria-label="Quitar"><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
    </div>
  );
};
